module.exports = __webpack_public_path__ + "static/media/1007591.c2bfb8ff.png";